import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
  iconfont: 'mdi',
})


// Vue.use(Vuetify)
// , {
//   // theme: {
//   //   tile: "#F3F3F3",
//   //   // primary: "#757575",
//   //   primary: colors.grey.darken3,
//   //   // secondary: "#ffd740",
//   //   secondary: colors.lightBlue,
//   //   accent: colors.amber,
//   //   error: colors.red.accent3,
//   //   interface: colors.grey.lighten3,
//   // },
//   iconfont: 'mdi', // 'md' || 'mdi' || 'fa' || 'fa4',
  
// });s